import Axios, { AxiosResponse } from "axios";
import { DelarProductDto, DelarProductPackDto, DelarProductSearchDto, ProductSearchDto } from "./dto/product.dto";
import { DelarProduct, DelarProductInfoRes, DelarProductPackRes, DelarProductRes, DelarProductSearchResult, DelarProductSearchResultRes, Product } from "./response/product.response";

export const ProductService = {
    getDelarProductList: (delarProductSearchDto: DelarProductSearchDto): Promise<AxiosResponse<DelarProductRes>> => {
        return Axios.post<DelarProductRes>(`/delar-product-search`, delarProductSearchDto)
    },
    getProductList: (productSearchDto: ProductSearchDto): Promise<AxiosResponse<DelarProductSearchResultRes>> => {
        return Axios.post<DelarProductSearchResultRes>(`/product-search`, productSearchDto)
    },
    addDelarProductList: (delarProductDtoList: Array<DelarProductDto>): Promise<AxiosResponse<Array<DelarProductSearchResult>>> => {
        return Axios.post<Array<DelarProductSearchResult>>(`/add-delar-product-list`, delarProductDtoList)
    },
    getDelarProductById: (delarProductId: string): Promise<AxiosResponse<DelarProduct>> => {
        return Axios.get<DelarProduct>(`/delar-product/${delarProductId}`)
    },
    getDelarProductInfoById: (delarProductId: string): Promise<AxiosResponse<DelarProductInfoRes>> => {
        return Axios.get<DelarProductInfoRes>(`/delar-product-detail/${delarProductId}`)
    },
    addDelarProductPack: (delarProductPackDto: DelarProductPackDto): Promise<AxiosResponse<DelarProductPackRes>> => {
        return Axios.post<DelarProductPackRes>(`/delar-product-packs-update`, delarProductPackDto)
    },
}